import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@carm/_auth/spartacus/core/auth';
import { NotificationService } from '@carm/_core/notification-mgt/facade/notifcation.service';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Subscription } from 'rxjs';
import { DeploymentWarningModalComponent } from '../deployment-warning-modal/deployment-warning-modal.component';
import { modalDeploymentConfig } from '../models/deployment-model';
import { DeploymentTimeoutService } from '../services/deployment-timeout.service';
import { interval } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    template: '',
    selector: 'carm-deployment-timeout',
})
export class DeploymentTimeoutComponent implements OnInit {

  nextDeploymentTime: string | null = null;
  remainingMinutes: number = 0;
  isFinalWarningMessageVisible = false;
  isWarningMessageModalVisible = false;
  dialogRef: MatDialogRef<DeploymentWarningModalComponent>;
  private deploymentCheckSubscription: Subscription | null = null;
  deploymentWarningSettings = {
    maintenanceAlertPopupBefore: environment.deploymentWarningSettings?.maintenanceAlertPopupBefore
    ? environment.deploymentWarningSettings?.maintenanceAlertPopupBefore : 60, // 1 hour before by default
    finalMaintenanceAlertBefore: environment.deploymentWarningSettings?.finalMaintenanceAlertBefore
    ? environment.deploymentWarningSettings?.finalMaintenanceAlertBefore : 5, // 5 minutes before by default
  };

  constructor(
    private deploymentService: DeploymentTimeoutService,
    private notificationSerivce: NotificationService,
    private translateService: TranslateService,
    private authService: AuthService,
    private dialog: MatDialog
  ) {
    this.deploymentService.startFetchingDeploymentTime();
  }

  ngOnInit(){
    this.authService.isUserLoggedIn().subscribe(isUserLoggedIn => {
      isUserLoggedIn ? this.startDeploymentCheck() : this.stopDeploymentCheck();
    });

    combineLatest([
      this.authService.isUserLoggedIn(),
      this.deploymentService.isNextDeploymentTimeUpdated()
    ]).subscribe(([isUserLoggedIn, isNextDeploymentTimeChange]) => {
      if (isNextDeploymentTimeChange && isUserLoggedIn){
        this.checkDeploymentTime();
      }
    });
  }

  private startDeploymentCheck() {
    // Start the interval for deployment checks
    this.checkDeploymentTime();
    this.deploymentCheckSubscription = interval(20000).subscribe(() => { //check in every 20 second to show modal or popup
      this.checkDeploymentTime();
    });
  }

  private stopDeploymentCheck() {
    // Stop the deployment check interval
    if (this.deploymentCheckSubscription) {
      this.deploymentCheckSubscription.unsubscribe();
      this.deploymentCheckSubscription = null;
    }
    this.isFinalWarningMessageVisible = false;
    this.isWarningMessageModalVisible = false;
    this.notificationSerivce.clearDeploymentNotification();
  }

  private checkDeploymentTime() {
    this.nextDeploymentTime = localStorage.getItem('nextDeploymentTime');
    if (this.nextDeploymentTime) {
      const deploymentDate = new Date(this.nextDeploymentTime);
      const now = Date.now();
      const remainingTime = deploymentDate.getTime() - now;

      // Calculate remaining minutes
      this.remainingMinutes = Math.ceil(remainingTime / (1000 * 60));
      // Show modal if there are 10 minutes or less remaining
      if( this.remainingMinutes <= this.deploymentWarningSettings.maintenanceAlertPopupBefore
        && this.remainingMinutes > this.deploymentWarningSettings.finalMaintenanceAlertBefore
        &&  this.remainingMinutes > 0 // if less then one hour then show message or greater then 5 min
        && !localStorage.getItem('warn-deployment')
        && !this.isWarningMessageModalVisible) {
        this.openDialog(this.remainingMinutes);
        this.isWarningMessageModalVisible = true;
      }

      if(this.remainingMinutes <= this.deploymentWarningSettings.finalMaintenanceAlertBefore
         && this.remainingMinutes > 0
         && !this.isFinalWarningMessageVisible){ // if 5 minutes left then show snackbar
        this.notificationSerivce.setDeploymentWarningMessage(
          this.translateService.instant(`modal_deployment_timeout.maintenance_snake_message`),
          this.translateService.instant(`modal_deployment_timeout.title`)
        );
        this.isFinalWarningMessageVisible = true;
      }

      if(this.remainingMinutes > this.deploymentWarningSettings.finalMaintenanceAlertBefore
        && this.remainingMinutes > 0
        && this.isFinalWarningMessageVisible){ //  reset snakebar if time reset and remaning time is greater than new value
       this.notificationSerivce.clearDeploymentNotification();
       this.isFinalWarningMessageVisible = false;
     }

     if(this.remainingMinutes == 0 && this.isFinalWarningMessageVisible){ //  remove snake bar if remaining minutes are 0
       this.notificationSerivce.clearDeploymentNotification();
       this.isFinalWarningMessageVisible = false;
       this.deploymentService.fetchDeploymentTime();
     }

    }
  }

  openDialog(timeRemaining: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = modalDeploymentConfig.panelClass;
    dialogConfig.backdropClass = modalDeploymentConfig.backdropClass;
    dialogConfig.data = null;
    this.dialogRef = this.dialog.open(DeploymentWarningModalComponent, dialogConfig);
    this.dialogRef
      .afterClosed()
      .subscribe((buttonInfo: any) => {
        this.isWarningMessageModalVisible = true;
      });
  }

  closeDialog() {
    this.dialogRef = null;
  }

}
